import { Type } from 'class-transformer';
import { CarModel } from '@services/car-model';
import { FleetVehicle } from '@services/fleet-vehicle';

export class CurrentVehicle {
	@Type(() => CarModel)
	model: CarModel;

	@Type(() => FleetVehicle)
	vehicle: FleetVehicle;
}
